class QuantityInput extends HTMLElement {

	static formAssociated = true;

	constructor() {

		super();


		this.internals_ = typeof this.attachInternals == "function" ? this.attachInternals() : undefined;
		this.input = this.querySelector("input");
		this.minus = this.input.previousElementSibling;
		this.plus = this.input.nextElementSibling;
		this.changeEvent = new Event("change", { bubbles: true });
		this.allowZero = this.dataset.allowZero || false;
		this.min = this.input.min || 1;
		this.buttons = this.querySelectorAll("button");
		this.buttons.forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
	}

	onButtonClick(event) {
		const previousValue = this.input.value;

		event.target.name === "plus"
			? this.input.stepUp()
			: this.input.stepDown();

		if (this.input.value > this.min) {
			this.minus.disabled = false;
		} else {
			this.minus.disabled = true;
		}

		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

class FixedAddToCart extends HTMLElement {

	constructor() {

		super();

		this.formId = this.dataset.form;
		this.form = document.getElementById(`${this.formId
			}_form`);
		this.formAtc = this.form.querySelector("[name='add']");
		this.triggerAtc = this.querySelector("[name='trigger']");

		this.triggerAtc.addEventListener("click", this.triggerAddToCart.bind(this));
	}

	triggerAddToCart() {

		this.formAtc.click();
	}
}

class VariantSelects extends HTMLElement {

	constructor() {

		super();

		this.form = this.closest("form");
		this.append = (this
			.form
			.parentElement
			.dataset
			.append)
			? this
				.form
				.parentElement
				.dataset
				.append
			: "";
		this.update = (this
			.form
			.parentElement
			.dataset
			.update && this
				.form
				.parentElement
				.dataset
				.update == "true")
			? true
			: false;
		this.btn = this.form.querySelector("[name='add']");
		this.btnText = this.btn.querySelector("span");
		this.price = document.getElementById(`${this.dataset.section + this.append
			}_form_price`);
		this.subscription = document.getElementById(`${this.dataset.section + this.append
			}_form_subscription`);
		this.variantData = (this.querySelector("[name='variants']"))
			? JSON.parse(this.querySelector("[name='variants']").value)
			: {};

		this.addEventListener("change", this.onVariantChange);

		if (this.subscription) {

			this.subscriptionSelected = "";
			this.subscriptionIntervalSelected = "";

			this.bindSubscriptionEvents();
		}
	}

	onVariantChange() {

		this.updateOptions();
		this.updateId();
		this.toggleAddButton(true, "");
		this.updatePickupAvailability();
		this.removeErrorMessage();

		if (!this.currentVariant) { // this.toggleAddButton(true, "")
			this.setUnavailable();

			return;
		}

		this.updateMedia();
		this.updateUrl();
		this.updateVariantInput();
		this.renderProductInfo();

		if (this.subscription) {
			this.bindSubscriptionEvents(this.subscriptionSelected);
		}
	}

	onSubscriptionChange(event) {
		this.subscriptionSelected = event.target.value;
	}

	bindSubscriptionEvents() {

		if (!this.subscription)
			return;


		this.subscriptionToggles = this.subscription.querySelectorAll("[type='radio']");
		this.subscriptionIntervals = this.subscription.querySelector("select");

		/** Bind our input change */
		this.subscriptionToggles.forEach((input) => {
			input.addEventListener("click", this.onSubscriptionChange.bind(this));
		});

		/** Bind our select change */
		this.subscriptionIntervals.addEventListener("change", (event) => {

			this.subscriptionIntervalSelected = event.target.value;
		});
	}

	updateOptions() {
		this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
	}

	updateId() {

		this.currentVariant = this.variantData.find((variant) => {
			return !variant.options.map((option, index) => {
				return this.options[index] === option;
			}).includes(false);
		});
	}

	updateMedia() {

		// TODO: Swap our media els
	} updateUrl() {

		if (!this.currentVariant || this.update === false)
			return;


		window.history.replaceState({}, "", `${this.dataset.url
			}${(
				this.dataset.url.includes("?")
					? "&"
					: "?"
			)
			}variant=${this.currentVariant.id
			}`);
	}

	updateVariantInput() {

		const productForms = document.querySelectorAll(`#${this.dataset.section + this.append
			}_form, #${this.dataset.section + this.append
			}_form_installment`);

		productForms.forEach((form) => {

			const input = form.querySelector("[name='id']");

			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updatePickupAvailability() {

		const pickupAvailability = document.querySelector("pickup-availability");

		if (!pickupAvailability)
			return;


		if (this.currentVariant && this.currentVariant.available) {

			pickupAvailability.fetchAvailability(this.currentVariant.id);

			return;
		}

		pickupAvailability.removeAttribute("available");
		pickupAvailability.innerHTML = "";
	}

	removeErrorMessage() {

		if (!this.form)
			return;


		const handleForm = this.form.closest("product-form");

		if (!handleForm)
			return;


		handleForm.handleErrorMessage();
	}

	/** Actually odd this pulls markup, maybe change? */
	renderProductInfo() {

		fetch(`${this.dataset.url
			}${(
				this.dataset.url.includes("?")
					? "&"
					: "?"
			)
			}variant=${this.currentVariant.id
			}&section_id=${this.dataset.section
			}`).then((response) => response.text()).then((responseText) => {

				const html = new DOMParser().parseFromString(responseText, "text/html");
				const pricingSource = html.getElementById(`${this.dataset.section + this.append
					}_form_price`);
				const subscriptionSource = html.getElementById(`${this.dataset.section + this.append
					}_form_subscription`);

				if (this.price && pricingSource)
					this.price.innerHTML = pricingSource.innerHTML;

				if (this.price)
					this.price.classList.remove("visibility-hidden");


				if (this.subscription && subscriptionSource)
					this.subscription.innerHTML = subscriptionSource.innerHTML;

				if (this.subscription)
					this.subscription.classList.remove("visibility-hidden");


				/** Going to need to reset our subscription */
				// TODO: Reset this.subscriptionToggles, it's overwritten
				if (this.subscription) {

					this.subscriptionToggles.forEach((input) => {


						if (input.value == this.subscriptionSelected) {
							input.click();
						}

						// input.addEventListener("change", this.onSubscriptionChange.bind(this));
					});
				}

				this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
			});
	}

	toggleAddButton(disable = true, text) {

		if (!this.form || !this.btn)
			return;


		if (disable) {

			this.btn.setAttribute("disabled", "disabled");

			if (text)
				this.btnText.textContent = text;


			return;
		}

		this.btn.removeAttribute("disabled");
		this.btnText.textContent = window.variantStrings.addToCart;
	}

	/**  */
	setUnavailable() {

		if (!this.btn)
			return;


		this.btnText.textContent = window.variantStrings.unavailable;

		if (this.price)
			this.price.classList.add("visibility-hidden");

	}
}

class VariantRadios extends VariantSelects {

	constructor() {

		super();

		this.addEventListener("change", this.onVariantChange);
	}

	updateOptions() {

		const fieldsets = Array.from(this.querySelectorAll("fieldset"));

		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
		});
	}
}

export {
	FixedAddToCart,
	QuantityInput,
	VariantSelects,
	VariantRadios
}
